export enum VideoAnalyticsEnum {
  TotalEventCount = 'total_event_count',
  UniqueEventCount = 'unique_event_count',
  EventDuration = 'event_duration',
  AverageEventDuration = 'average_event_duration',
}
